import React from "react";
import "../Css/weprovide.css";
import Charities from "../Img/What-we-provide/Charities.jpg";
import herapeutically from "../Img/What-we-provide/herapeutically-LED.jpg";
import NurtureTeamSessions from "../Img/What-we-provide/Nurture-Team-Sessions.jpg";
import ReflectivePracticeSessions from "../Img/What-we-provide/Reflective Practice Sessions.jpg";
function Weprovide() {
  return (
    <>
      <div className="we-provide-bg">
        <div className="container">
          <div className="breadcrumb-container">
            <ul className="breadcrumbs">
              <li>
                <a href="/">Home</a>
              </li>
              <li>What We Provide</li>
            </ul>
          </div>

          <h2 className="banner-heading">What We Provide</h2>
        </div>
      </div>

      <section className="py-5">
        <div className="container">
          <h2 class="sub-heading text-center">What we provide our children</h2>
          <p className=" text-center pb-4">
            The team at Affinity Childrens provides safe, supportive, and
            nurturing homes for children who have experienced trauma. Our
            Psychologists and Therapists work closely every day with our care
            staff and children, using a trauma-informed, attachment-aware, and
            brain-based approach. We offer personalised therapies and meaningful
            activities that suit each child’s needs, helping them understand
            their experiences, build emotional strength, and move forward with
            confidence. <br />
            <br />
            Our homes are designed to give children a stable and loving
            environment where they feel safe, secure, and truly included. Many
            of the children we support have faced difficult life experiences, so
            it is essential that we provide a home where they can be themselves
            and feel accepted. In a warm and homely setting, we help children
            express their emotions, manage their feelings, and begin their
            healing journey through our structured care and support pathway.
          </p>

          <div className="row g-4 img-card">
            <div className="col-md-6">
              <div className="img-box">
                <img
                  src={herapeutically}
                  alt="Dandelion House"
                  className="weorovide-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="card-content">
                <h5 className="card-title">
                  Therapeutically LED Specialist Training
                </h5>

                <p className="pt-2">
                  Every member of our nurture care team has undertaken our
                  in-house training programme. This allows us to provide our
                  team with the specialist training they need to work with
                  traumatised children, to understand how and why therapeutic
                  parenting is essential and to be confident in using our PACE
                  based methods (playfulness, acceptance, curiosity, and
                  empathy).
                </p>
              </div>
            </div>
          </div>

          <div className="row g-4 img-card">
            <div className="col-md-6">
              <div className="img-box">
                <img
                  src={ReflectivePracticeSessions}
                  alt="Dandelion House"
                  className="weorovide-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="card-content">
                <h5 className="card-title">
                  Reflective Practice Sessions for our teams
                </h5>

                <p className="pt-2">
                  We provide clinically-led reflective practice sessions for our
                  nurture team. This allows our care team to explore best
                  practice, use and build on their reflective practice skills
                  and develop their skills to an enhanced level openly and
                  safely.
                </p>
              </div>
            </div>
          </div>

          <div className="row g-4 img-card">
            <div className="col-md-6">
              <div className="img-box">
                <img
                  src={NurtureTeamSessions}
                  alt="Dandelion House"
                  className="weorovide-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="card-content">
                <h5 className="card-title">Nurture Team Well-being Sessions</h5>

                <p className="pt-2">
                  We provide our nurture team with access to monthly well-being
                  sessions for them. These often incorporate mindfulness and
                  relaxation as well as self-care and wellness and helps ensure
                  our care team are always feeling their best and performing to
                  the best of their abilities.
                </p>
              </div>
            </div>
          </div>

          <div className="row g-4 img-card">
            <div className="col-md-6">
              <div className="img-box">
                <img
                  src={Charities}
                  alt="Dandelion House"
                  className="weorovide-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="card-content">
                <h5 className="card-title">Charities</h5>

                <p className="pt-2">
                  We’re passionate about giving back to our local community and
                  supporting those around us, that’s why we aim to provide
                  support and assistance to our local children’s charities and
                  hospitals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Weprovide;
